import { JSONPath } from 'jsonpath-plus'
import { isArray, isEqual } from 'lodash-es'

import { Data, JsonUpdate } from '../../domain'
import {
  AdjustmentUpdate,
  AssetChangeConfig,
  InputConfig,
  NestedUpdate,
  ProfileChangeConfig,
  QuoteChangeConfig,
  Update,
} from '../../state/configuration'

export const isNestedUpdate = (update: Update): update is NestedUpdate =>
  Object.hasOwn(update, 'id')

export const toData = (data: Data, update: AdjustmentUpdate): Data =>
  isArray(update)
    ? update.reduce(
        (acc, update) => ({
          ...acc,
          [update.id]: JSONPath({ path: update.path, json: data, wrap: false }),
        }),
        {},
      )
    : JSONPath({ path: update.path, json: data, wrap: false })

const getUpdateData = (fieldName: string, update: NestedUpdate | Update, data: Data) => {
  return isNestedUpdate(update) ? data[fieldName]?.[update.id] : data[fieldName]
}

export const toUpdates =
  (existingData: Data, data: Data) =>
  (
    fieldName: string,
    adjustment: ProfileChangeConfig | AssetChangeConfig | QuoteChangeConfig,
  ): JsonUpdate[] => {
    const updates = isArray(adjustment.update) ? adjustment.update : [adjustment.update]

    return updates
      .filter(
        (it) =>
          !isEqual(
            getUpdateData(fieldName, it, existingData),
            getUpdateData(fieldName, it, data),
          ),
      )
      .map((it) => ({
        path: it.path,
        value: getUpdateData(fieldName, it, data),
        attribute: it.attribute,
      }))
  }

export const hasUpdates = (existingData: Data, data: Data) => (input: InputConfig) =>
  !isEqual(existingData[input.name], data[input.name])
